import { Role } from "@xapp/stentor-api-client/dist/models/Roles";
import { StentorAdmin } from "auth/modules/roles";
import { UserProfile } from "auth/modules/state";
import classnames from "classnames";
import { Organization } from "generated/graphql";
import React, { PureComponent } from "react";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { FontIcon } from "react-toolbox/lib/font_icon";
import lists from "styles/lists.scss";
import style from "./style.scss";
import { isSidebarNavItem } from "./utils";

interface SidebarItem {
    allowedRoles?: (Role | StentorAdmin)[];
    icon: string;
    name: string;
}

export interface SidebarButton extends SidebarItem {
    onClick(args: any): void;
}

export interface SidebarNavItem extends SidebarItem {
    path: string;
}

export interface SidebarNavMenuViewOwnProps extends RouteComponentProps<any> {
    navItems: (SidebarNavItem | SidebarButton)[];
}

export interface SidebarNavMenuViewStateProps {
    asUser?: boolean;
    user: UserProfile;
    org?: Organization;
}

export type SidebarNavMenuViewProps = SidebarNavMenuViewOwnProps & SidebarNavMenuViewStateProps;

interface SidebarNavMenuState {
    isHovered: boolean;
}

const SIDEBAR_IS_HOVERED = "SIDEBAR_IS_HOVERED";

export class SidebarNavMenuView extends PureComponent<SidebarNavMenuViewProps, SidebarNavMenuState> {
    private hoverTimeout: number;

    constructor(props: SidebarNavMenuViewProps) {
        super(props);

        this.state = {
            isHovered: this.getInitialHoverState()
        };

        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    getInitialHoverState(): boolean {
        return sessionStorage && sessionStorage.getItem(SIDEBAR_IS_HOVERED) === "true";
    }

    handleMouseEnter() {
        this.hoverTimeout = window.setTimeout(() => {
            this.setState({ isHovered: true });

            if (sessionStorage) {
                sessionStorage.setItem(SIDEBAR_IS_HOVERED, "true");
            }
        }, 1000);
    }

    handleMouseLeave() {
        this.setState({ isHovered: false });
        window.clearTimeout(this.hoverTimeout);

        if (sessionStorage) {
            sessionStorage.setItem(SIDEBAR_IS_HOVERED, "false");
        }
    }

    render() {
        let drawerStyle = style.drawer;

        if (this.state.isHovered) {
            drawerStyle = classnames(style.drawer, style.isOpen);
        }

        function renderNavItem(navItem: SidebarNavItem, i: number) {
            return (
                <li key={i}>
                    <NavLink activeClassName="isActive" title={navItem.name} to={navItem.path} className={style.item}>
                        <span className={style.icon}>
                            <FontIcon value={navItem.icon} />
                        </span>

                        <span className={style.name}>{navItem.name}</span>
                    </NavLink>
                </li>
            );
        }

        function renderNavButton(navItem: SidebarButton, i: number) {
            return (
                <li key={i}>
                    <button className={style.item} onClick={navItem.onClick}>
                        <span className={style.icon}>
                            <FontIcon value={navItem.icon} />
                        </span>

                        <span className={style.name}>{navItem.name}</span>
                    </button>
                </li>
            );
        }

        return (
            <div className={drawerStyle} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
                <ul className={lists.unstyled}>
                    {this.props.navItems.map((navItem: SidebarNavItem, i: number) => {
                        if (isSidebarNavItem(navItem)) {
                            return renderNavItem(navItem, i);
                        } else {
                            return renderNavButton(navItem, i);
                        }
                    })}
                </ul>
            </div>
        );
    }
}
